document.addEventListener('DOMContentLoaded', function() {
  const modalContent = document.querySelector('.modal-content-video-editor');
  
  // Only add scroll listener if the element exists
  if (modalContent) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        modalContent.style.top = '0px';
      } else {
        modalContent.style.top = '100px';
      }
    });
    
    // Run on page load too
    window.dispatchEvent(new Event('scroll'));
  }
});